exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-container {\n  position: relative; }\n  .map-container .map-overlay {\n    z-index: 1000;\n    position: relative;\n    top: -100%;\n    pointer-events: none;\n    background: transparent;\n    width: 100%;\n    height: 100%; }\n    .map-container .map-overlay .controls-container {\n      width: 100%;\n      height: 100%;\n      pointer-events: none; }\n      :host /deep/ .map-container .map-overlay .controls-container .top-left {\n        position: absolute;\n        top: 0;\n        left: 0;\n        display: inline-table;\n        height: 100%; }\n      :host /deep/ .map-container .map-overlay .controls-container .top-right {\n        position: absolute;\n        top: 0;\n        right: 0;\n        display: inline-table;\n        height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/core/maps/map.component.scss
// module id = ../../../../../src/app/core/maps/map.component.scss
// module chunks = 0